<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
            <!-- <b-form-group label="Storefront:">
              <b-v-select
                v-model="formFilters.projectId"
                :searchable="true"
                :options="projectsFilter"
              />
            </b-form-group> -->
            <b-form-group label="Status:">
              <b-v-select
                v-model="formFilters.status"
                :options="statusFilters"
              />
            </b-form-group>
            <b-form-group label="Type:" v-if="!type">
              <b-v-select
                v-model="formFilters.type"
                :searchable="true"
                :options="reportTypesFilters"
              />
            </b-form-group>
            <b-form-group label="Search:">
              <b-form-input v-model="formFilters.search" />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <b-row class="align-items-end">
          <div class="col">
            <h1 class="header-title">
              {{heading}}
            </h1>
          </div>
          <div class="col-auto">

            <b-button variant="warning"
              :to="{ name: 'Reports.GeneratedReports.Index', params: { type: 'OrderedStorefrontItemsReport'} }"
              class="mr-2"
              v-if="type == 'OrderedWarehouseItemsReport'"
            >
              View by Storefront
            </b-button>
            <b-button variant="warning"
              :to="{ name: 'Reports.GeneratedReports.Index', params: { type: 'OrderedWarehouseItemsReport'} }"
              class="mr-2"
              v-else-if="type == 'OrderedStorefrontItemsReport'"
            >
              View by Warehouse
            </b-button>
            <b-button variant="info"
              @click="loadItems"
              class="mr-2"
            >
              <i class="fa fa-refresh" />
            </b-button>
            <router-link
              :to="{ name: 'Reports.GeneratedReports.Create', params: {type: type} }"
              class="btn btn-success mr-2"
            >
              <i class="mr-2 fa fa-plus" />
              New Report
            </router-link>
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </b-row>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fieldsForType"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(user)="data">
        <div>
          <span
          v-if="
          data.item.byUserInfo && data.item.byUserInfo.fullName"
          >{{ data.item.byUserInfo.fullName }} </span
        >
        <span v-else> Unknown </span>
        </div>
      </template>

      <template v-slot:cell(status)="data">
        <template v-if="data.item.status == 'Failed'">
          <label class="badge badge-danger"><i class="fa fa-check" /> Failed</label>
        </template>
        <template v-if="data.item.status == 'Processing'">
          <label class="badge badge-warning"><i class="fa fa-check" /> Processing</label>
        </template>
        <template v-if="data.item.status == 'Ready'">
          <label class="badge badge-success badge-green"><i class="fa fa-check" /> Ready</label>
        </template>
      </template>

      <template v-slot:cell(active)="data">
        <span v-if="data.item.active">Active</span>
        <span v-else>Deactivated</span>
      </template>
      <template v-slot:cell(createDateTimeUtc)="data">
        <span
          v-if="
            data.item.createDateTimeUtc &&
              !data.item.createDateTimeUtc.endsWith('Z')
          "
          >{{
            (data.item.createDateTimeUtc + 'Z') | moment('MMM Do YY, h:mm a')
          }}</span
        >
        <span v-else-if="data.item.createDateTimeUtc">{{
          data.item.createDateTimeUtc | moment('MMM Do YY, h:mm a')
        }}</span>
      </template>

      <template v-slot:cell(factoringFinanceInvoiceFilters.brandId)="data">
        <span
          v-if="data.item.factoringFinanceInvoiceFilters && myBrands && myBrands.find(a => a.id == data.item.factoringFinanceInvoiceFilters.brandId)"
          >{{ myBrands.find(a => a.id == data.item.factoringFinanceInvoiceFilters.brandId).name | truncate(15) }}</span
        >
        <span v-else>-</span>
      </template>
      <template v-slot:cell(factoringFinanceInvoiceFilters.warehouseId)="data">
        <span
          v-if="data.item.factoringFinanceInvoiceFilters && myWarehouses && myWarehouses.find(a => a.id == data.item.factoringFinanceInvoiceFilters.warehouseId)"
          >{{ myWarehouses.find(a => a.id == data.item.factoringFinanceInvoiceFilters.warehouseId).name }}</span
        >
        <span v-else>- ANY -</span>
      </template>

      <template v-slot:cell(id)="data">
        <b-button
          variant="info"
          class="ml-1"
          :disabled="(data.item.status != 'Ready')"
          :to="{
            name: 'Reports.GeneratedReports.View',
            params: { id: data.item.id }
          }"
        >
          View
        </b-button>
        <b-button
          variant="primary"
          class="ml-1"
          :disabled="(data.item.status != 'Ready')"
          @click="DownloadReport(data.item)"
        ><i class="fa fa-download mr-1" />
          .xlsx
        </b-button>
        <b-button
          variant="primary"
          class="ml-1"
          v-if="data.item.type == 'FactoringFinanceInvoiceReport'"
          :disabled="(data.item.status != 'Ready')"
          @click="DownloadReportWareTransactions(data.item)"
        ><i class="fa fa-download mr-1" />
          Transactions
        </b-button>
      </template>
    </TableListing>
  </section>
</template>

<script>
import { TableListing } from '@/views/components/custom';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'Reports.GeneratedReports.Index',
  mixins: [crudMixinGen('generatedReports'), myCommonDataMixin],
  components: {
    TableListing
  },
  props: {
    type: {
      type: String,
      required: false,
      default: ''
    }
  },
  meta() {
    let titl = (this.heading) ? this.heading : 'Generated Reports';
      return {
          title: titl,
          // ...
      };
  },
  data: () => ({
    heading: 'Generated Reports',
    statusFilters: [
      {
        value: '',
        text: 'Show All'
      },
      {
        value: 'Ready',
        text: 'Ready'
      },
      {
        value: 'Requested',
        text: 'Requested'
      },
      {
        value: 'Processing',
        text: 'Processing'
      },
      {
        value: 'Failed',
        text: 'Failed'
      }
    ],
    reportTypesFilters: [
      {
        value: '',
        text: 'Show All'
      },
      {
        value: 'OrderedStorefrontItemsReport',
        text: 'Ordered Storefront Items'
      },
      {
        value: 'OrderedWarehouseItemsReport',
        text: 'Ordered Warehouse Items'
      },
      {
        value: 'OrderFulfillmentsReport',
        text: 'Order Fulfillments'
      },
      {
        value: 'StorefrontShippedCount',
        text: 'Storefront Shipments Count'
      },
      {
        value: 'WarehouseItemsInOutReport',
        text: 'Warehouse Transactions Summary'
      },
      {
        value: 'ReportItemsOnBackorder',
        text: 'Items On Backorder'
      }
    ]
  }),
  mounted() {
    if (this.type) {
      if (this.type == 'OrderedStorefrontItemsReport')
        this.heading = 'Ordered Items Report - Storefront';
      else if (this.type == 'FactoringFinanceInvoiceReport')
        this.heading = 'Factoring Invoices';
      else if (this.type == 'OrderedWarehouseItemsReport')
        this.heading = 'Ordered Items Report - WMS';
      else if (this.type == 'OrderFulfillmentsReport')
        this.heading = 'Storefront Fulfillments';
      else if (this.type == 'StorefrontReshipReportByMonth')
        this.heading = 'Reships By Month';
      else if (this.type == 'StorefrontShippedCount')
        this.heading = 'Storefront Shipped Orders';
      else if (this.type == 'WarehouseItemsInOutReport')
        this.heading = 'Warehouse Transactions Summary';
      else if (this.type == 'ReportFinanceMargin')
        this.heading = 'Client Billing: By Order Margin';
      else if (this.type == 'ReportFinanceMarginSummary')
        this.heading = 'Client Billing: Margin Summary';
      else if (this.type == 'ReportItemsOnBackorder')
        this.heading = 'Items On Backorder';

      this.formFilters.type = this.type;
      this.itemsFilters.type = this.type;
    }
    this.loadItems();
  },
  watch: {
    'type': function(val) {
      if (this.type) {
        if (this.type == 'OrderedStorefrontItemsReport')
          this.heading = 'Ordered Items Report - Storefront';
        else if (this.type == 'FactoringFinanceInvoiceReport')
          this.heading = 'Factoring Invoices';
        else if (this.type == 'OrderedWarehouseItemsReport')
          this.heading = 'Ordered Items Report - WMS';
        else if (this.type == 'OrderFulfillmentsReport')
          this.heading = 'Storefront Fulfillments';
        else if (this.type == 'StorefrontShippedCount')
          this.heading = 'Storefront Shipped Orders';
        else if (this.type == 'WarehouseItemsInOutReport')
          this.heading = 'Warehouse Transactions Summary';
        else if (this.type == 'ReportItemsOnBackorder')
          this.heading = 'Items On Backorder';

        this.formFilters.type = this.type;
        this.itemsFilters.type = this.type;
      }
      this.loadItems();
    }
  },
  computed: {
    fieldsForType: {
      get() {
        let tableFields = [
          { key: 'name', label: 'Report', sortable: false },
          { key: 'createDateTimeUtc', label: 'Requested At', sortable: false },
          { key: 'status', label: 'Status', sortable: false },
        ];
        if(!this.is('brand-user')) {
          tableFields.push({ key: 'user', label: 'By', sortable: false })
        }
        if(this.type == 'FactoringFinanceInvoiceReport') {
          tableFields.push({ key: 'factoringFinanceInvoiceFilters.brandId', label: 'Client', sortable: false })
          tableFields.push({ key: 'factoringFinanceInvoiceFilters.warehouseId', label: 'From Warehouse', sortable: false })
        }
        tableFields.push({ key: 'id', label: 'Action', sortable: false });
        return tableFields;
      },
      set() {

      }
    }
  },
  methods: {
    DownloadReportWareTransactions(item) {
      let form= document.createElement('form');
      form.setAttribute('method', 'post');
      form.setAttribute('target', '_blank');
      form.setAttribute('action', process.env.VUE_APP_API_URL + '/download/generatedReport/factoring-transactions/'+item.id);
      document.body.appendChild(form); // Not sure if this step is necessary
      form.submit();
    },
    DownloadReport(item) {
      let form= document.createElement('form');
      form.setAttribute('method', 'post');
      form.setAttribute('target', '_blank');
      form.setAttribute('action', process.env.VUE_APP_API_URL + '/download/generatedReport/'+item.id);
      document.body.appendChild(form); // Not sure if this step is necessary
      form.submit();
    }
  }
};
</script>
